import styles from './Lobby.module.css';
import { useCallback, useEffect, useState, useRef } from 'react';

import LandAcknowledgement from './LandAcknowledgement';
import SiteBeacon from './SiteBeacon.js';
import FoldVideo from './FoldVideo.js';
import FoldSummary from './FoldSummary.js';
import AboutMe from './AboutMe.js';
import Footer from './Footer.js';
import ServiceSections from './ServiceSections.js';
import ServiceSection from './ServiceSection.js';
import Services from './Services.js';
import BannerImage from './BannerImage.js';


import { BrowserRouter, useLocation } from 'react-router-dom';


import { JLLServices } from '../data/JLLServices.js';


function Lobby({ jazz }) {

    const location = useLocation();
    const pageContent = document.getElementById("pageContent");
    const footerElement = document.getElementById("footer");

    const [backToFooter, setBackToFooter] = useState(false);

    useEffect(() => {
        if (location.hash === "") {
            if (backToFooter) {
                if (footerElement) footerElement.scrollIntoView();
            } else {
                if (pageContent) pageContent.scrollTo(0, 0);
            }
        } else {
            if (document.getElementById(location.hash.substring(1))) {
                document.getElementById(location.hash.substring(1)).scrollIntoView();
            }
        }
    }, [location]);


    return (
        <div className={styles.lobby}>
            <div className={styles.mainFold}>
                <FoldVideo />
                <div id="pageContent" className={styles.pageContent}>
                    <FoldSummary setBackToFooter={setBackToFooter} />
                    {jazz ? (<AboutMe />) : <AboutMe />}
                    {JLLServices ? <ServiceSection serviceSection={JLLServices["design"]} /> : null}
                    {/*<ServiceSections />*/}
                    {JLLServices ? <ServiceSection serviceSection={JLLServices["illustration"]} /> : null}
                    <Services />

                    <BannerImage />

                    {jazz ? (<Footer setBackToFooter={setBackToFooter} />) : <Footer setBackToFooter={setBackToFooter} />}
                </div>
            </div>

        </div>

    );
}

export default Lobby;
